<template>
  <mu-container>
    <div class="navBar">
      <van-nav-bar
          v-if="!['首页', '我的', '充电实况', '经营参谋', '停车减免', '停车费申诉审核', '我的钱包', '结算日报', '站点管理'].includes($route.name)"
          :title="$route.name"
          :left-arrow="activeIndex === -1"
          @click-left="onClickLeft"
      />
    </div>
    <div class="Main" ref="Main">
      <transition name="fadeRightBig" leave-active-class="fadeRightBigIn">
        <router-view/>
      </transition>
    </div>
    <div class="bottom" v-if="activeIndex !== -1">
      <div
          v-for="(item, index) in bottomNav"
          :key="index"
          @click="navPush(item, index)"
          :style="index == activeIndex ? 'color:#2959F3' : 'color:#000'"
      >
        <img :src="index == activeIndex ? item.selectImg : item.img" alt=""/>
        <div>{{ item.label }}</div>
      </div>
    </div>
  </mu-container>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      bottomNav: [
        {
          path: "/admin/equipment",
          icon: "el-icon-tickets",
          label: "首页",
          img: require("@/assets/image/newImg/Tabbar/index_11.png"),
          selectImg: require("@/assets/image/newImg/Tabbar/index_12.png"),
        },
        {
          path: "/admin/realtime",
          icon: "el-icon-video-play",
          label: "充电实况",
          img: require("@/assets/image/newImg/Tabbar/index_21.png"),
          selectImg: require("@/assets/image/newImg/Tabbar/index_22.png"),
        },
        {
          path: "/admin/analysis",
          icon: "el-icon-s-marketing",
          label: "经营参谋",
          img: require("@/assets/image/newImg/Tabbar/index_31.png"),
          selectImg: require("@/assets/image/newImg/Tabbar/index_32.png"),
        },
      ],
    };
  },
  watch: {
    "$route.path": {
      deep: true,
      immediate: true,
      handler(v) {
        this.activeIndex = this.bottomNav.findIndex((item) => item.path === v);
        this.$nextTick(() => {
          this.$refs.Main.scrollTop = 0;
        });
      },
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    navPush(item, index) {
      this.activeIndex = index;
      this.$router.push({
        path: item.path,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  padding: 0.32rem 0;
  height: 1.867rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px #cccccc;

  img {
    height: 0.4533rem;
    margin-bottom: 0.16rem;
  }

  > div {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }

  ::v-deep .mu-bottom-item-text {
    font-size: 0.1944rem;
  }
}
</style>
